<script>
    import {USER_ROLES} from "../lib/constants";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import UserSelect from "../components/controls/UserSelect.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import UserEditModal from "../users/UserEditModal.svelte";
    import UserSelectModal from "../users/UserSelectModal.svelte";
    import {copyObjectData} from "../lib/lib";

    export let department = null;

    let userId = null;
    let selectedUsers = null;

    const save = (userIds) => {
        const onSuccess = result => {
            if (result.length < department.users.length) {
                Notifier.showMessage("User removed from department");
            } else {
                Notifier.showMessage("User related to department");
            }
            department.users = result;
        }

        const onFailure = err => {
            Alert.warning("Department", err.message);
        };

        R.handle(R.department.editUsers, {
            id: department.id,
            users: userIds
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const onCreate = () => {
        userId = 0;
    }

    const onAdd = ({detail: userObj}) => {
        let ids = [userObj.id, ...department.users.map(item => (item.id))];
        save(ids);
    }

    const onEdit = (user) => {
        userId = user.id;
    }

    const onRemove = (userObj) => {
        Alert.confirm("Remove user", `This will remove user "${userObj.name}" from department.\nAre you sure?`, () => removeUser(userObj.id));
    }

    const removeUser = (id) => {
        let ids = department.users.map(item => (item.id)).filter(x => x != id);
        save(ids);
    }

    const closeEdit = (userObj) => {
        if (userObj) {
            let item = department.users.find(x => x.id == userObj.id);
            if (item) {
                copyObjectData(userObj, item, true);
                department.users = department.users;
            } else {
                department.users = [userObj, ...department.users];
            }
        }
        userId = null;
    }

    const openModal = () => {
        selectedUsers = department.users.map(item => (item.id));
    }

    const closeModal = (selected) => {
        if (selected) {
            save(selected);
        }
        selectedUsers = null;
    }
</script>

<div class="panel panel-default">
    <div class="panel-heading py-2">
        Users
        <button class="btn btn-primary btn-xs" on:click="{ onCreate }" disabled="{ department.id == 0 }">
            CREATE USER
        </button>
    </div>
    {#if department.id > 0}
        <div class="panel-body p-2 border-bottom">
            <div class="tools-box">
                <UserSelect excludeFromSelection="{ department.users }" on:select="{ onAdd }"
                        placeholder="add existing user"/>
                <button class="btn btn-default btn-flex line-height-1 ms-1" title="select from list" on:click="{ openModal }">
                    <AppIcon icon="list" size="16" strokeWidth="2"/>
                </button>
            </div>
        </div>
        {#if department.users.length}
            <table class="table table-list">
                <tbody>
                {#each department.users as item}
                    <tr class="row-hover">
                        <td>
                            <div class="small">
                                { USER_ROLES[item.role] }
                            </div>
                            <span class="is-link" class:not-active={ item.is_active < 1 } on:click="{ () => onEdit(item) }">
                                { item.name }
                            </span>
                        </td>
                        <td class="button-column pointer" title="remove user from department" on:click="{ () => onRemove(item) }">
                            <AppIcon icon="x" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new department in order to add users
        </div>
    {/if}
</div>
{#if userId != null}
    <UserEditModal {userId} departmentId="{ department.id }" closeCallback="{ closeEdit }"/>
{/if}
{#if selectedUsers != null}
    <UserSelectModal selected={ selectedUsers } callbackHandler="{ closeModal }"/>
{/if}